<template lang="pug">
v-autocomplete(
  dense,
  v-model="dataBank",
  :disabled="disabled",
  :readonly="readonly",
  :label="label",
  :rules="rules",
  :items="listData",
  :item-text="text",
  item-value="bankId",
  @change="onSelect",
  :required="required"
)
</template>
<script>
export default {
  name: "FSelectBank",
  props: ["value", "disabled", "readonly", "label", "rules", "required"],
  data() {
    return {
      dataBank: {},
      listData: [],
    };
  },
  created() {
    this.doLoad();
  },
  mounted() {
    this.doInit(this.value);
  },
  watch: {
    value(val) {
      this.doInit(val);
    },
  },
  methods: {
    text: (item) => item.bankId + " - " + item.initialName,
    doInit(values) {
      this.dataBank = values ? values : null;
    },
    doLoad() {
      this.$http.get("/api/parameter/bank").then((success) => {
        this.listData = success.data;
        this.onSelect();
      });
    },
    onSelect() {
      this.$emit("input", this.dataBank);
      this.$emit("select", this.dataBank);
      this.$emit("bank", this.valueData());
    },
    valueData() {
      let result = null;
      this.listData.map((element) => {
        if (this.dataBank === element.bankId) {
          result = element;
        }
      });
      return result;
    },
  },
};
</script>